import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ptop-15 es-right-bar" }
const _hoisted_2 = { class: "row ptop-04 title-adjust pbottom-04" }

import addEcosystem from './addEcosystem.vue';
import rBarMoreMenu from "./rBarMoreMenu.vue";
import { ref, computed, watch } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useUiStore } from '@/stores/ui';
import { getTextBasedOnLanguage } from '@/functions/expression';
import gen from "@/functions/general";
import patientapi from "@/api/patientapi";
import { useI18n } from 'vue-i18n';
import { useAppUserStore } from '@/stores/appUser';
import appuserapi from "@/api/appuserapi";
import { FolderPatientApi, GetSummaryByPatientSummaryTypeEnum, PatientSummaryResponse } from '@/apiGenerate/medserver'
import { medServerApiConfig } from '@/config/medserver-api.config'
import { useRoute } from 'vue-router'
import { getSingleElement } from '@/utils/array-utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'rBarEcosystem',
  props: {
    reloadPatientData: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const appUserStore = useAppUserStore();

const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()
const { t } = useI18n();
const route = useRoute();

const folderPatientApi = new FolderPatientApi(medServerApiConfig);

const isEditable = computed(() => {
  return currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
});

const patientEcosystemResponse = computed(() => {
  return currentEntryStore.patientEcosystemResponse;
});

const reloadEcosystemData = computed(() => {
  return currentEntryStore.reloadEcosystemData;
})

//Drag 'N Drop
const isDraggingOverEcosystem = ref(false);

function onDragOverEcosystem() {
  if (currentEntryStore.dndType !== 'exprEcosystem') {
    isDraggingOverEcosystem.value = true
  }  
}

function onDragLeaveEcosystem() {
  isDraggingOverEcosystem.value = false
}

async function onDropOnEcosystem() {
  isDraggingOverEcosystem.value = false;
  const dndType = currentEntryStore.dndType;
  const dndId = currentEntryStore.dndId;
  
  currentEntryStore.clearDnd();

  if (dndType !== 'exprEcosystem') {
    await patientapi.setConceptGroupForExpression(dndId, 'Ecosystem', currentEntryStore.currentEntryId, undefined);
    await loadEcosystemByPatient();
  }
}

function openAddEcosystem() {
  uiStore.setModalUiId("addEcosystem")
}

function openEcosystemDashBoard() {
  uiStore.setDashBoardType('Ecosystem')
}

async function dashbSelect(item) {

  const expressions = await folderPatientApi.getExpressionsByConceptGroupAndPatient({
    patientId : currentEntryStore.currentPatientId,
    conceptGroupId: item.conceptGroupId
  });
  currentEntryStore.allExpressions = expressions;
  
  const refSheetSuggestions = await appuserapi.getRefSheetsForExpr(item.expressionId)
  currentEntryStore.setCurrSuggestionsForDashboard(refSheetSuggestions)

  uiStore.setDashBoardItem(item)
}

const ecosystemList = computed(() => {
  if (!currentEntryStore.hasCurrentEntry) { return []; }

  const sctLanguage = appUserStore.currentAppUserData?.preferences?.sctLanguage;

  //Ecosystem: get last expression of each concept
  const allEcosystemLastExpr = patientEcosystemResponse.value.map(expr => gen.deepCopy(expr));

  //Add additional data
  let uiIndex = 0;

  allEcosystemLastExpr.forEach(expr => expr.text = getTextBasedOnLanguage(expr, sctLanguage));
  allEcosystemLastExpr.sort((a, b) => {return a.text.localeCompare(b.text)});

  //UI Index (AFTER sort)
  allEcosystemLastExpr.forEach(expr => {
    expr.id = gen.newId("rBarEcosystem", ++uiIndex);
  });

  return allEcosystemLastExpr;
});

const loadEcosystemByPatient = () => {
  folderPatientApi.getSummaryByPatient(({patientId: getSingleElement(route.params.patientId), summaryType: GetSummaryByPatientSummaryTypeEnum.Ecosystem })).then((result: PatientSummaryResponse[]) => {
    currentEntryStore.setPatientEcosystemResponse(result);
  });
}

watch(
  () => props.reloadPatientData,
  async () => {
    if (props.reloadPatientData) {
      await loadEcosystemByPatient();
    }   
  }
);

watch(
  () => reloadEcosystemData.value,
  async () => {
    if (reloadEcosystemData.value) {
      await loadEcosystemByPatient();
      currentEntryStore.setReloadEcosystemData(false);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onDragover: _withModifiers(onDragOverEcosystem, ["prevent"]),
      onDragleave: onDragLeaveEcosystem,
      onDrop: _withModifiers(onDropOnEcosystem, ["prevent"]),
      class: _normalizeClass([isDraggingOverEcosystem.value ? 'bigshadow' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mleft-08" }, null, -1)),
        _createVNode(_component_es_button, {
          label: _unref(t)('patient.rightBar.subtitle.ecosystem'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openEcosystemDashBoard())),
          "is-primary": false,
          "is-linked": true,
          widthClass: "w-full"
        }, null, 8, ["label"]),
        (_unref(currentEntryStore).dndType !== 'exprEcosystem' && isEditable.value)
          ? (_openBlock(), _createBlock(_component_es_button_icon, {
              key: 0,
              class: "square-29 justify-center",
              icon: "plus",
              folder: "shareIcons",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openAddEcosystem())),
              styles: "icon-grey-style square-14"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_itemModal, {
          center: true,
          uiId: "addEcosystem"
        }, {
          modal: _withCtx(() => [
            _createVNode(addEcosystem, {
              class: "item-modal",
              ecosystemAdded: loadEcosystemByPatient
            })
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ecosystemList.value, (expr, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "list"
        }, [
          _createVNode(_component_listGroup2, {
            class: "row mleft-10 w-full full-row",
            onClick: ($event: any) => (dashbSelect(expr))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_item, {
                txt: expr.text,
                class: "pad-s"
              }, null, 8, ["txt"]),
              (isEditable.value)
                ? (_openBlock(), _createBlock(rBarMoreMenu, {
                    key: 0,
                    expr: expr,
                    class: "mleft-auto",
                    refresh: loadEcosystemByPatient,
                    onSetDeletable: ($event: any) => (expr.deletable = false)
                  }, null, 8, ["expr", "onSetDeletable"]))
                : _createCommentVNode("", true),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mleft-04" }, null, -1))
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]))
      }), 128))
    ], 34)
  ]))
}
}

})